<script setup lang="ts"></script>

<template>
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1567_21973)">
      <path
        d="M9.16683 7.16667H12.5002L8.50016 11.1667L4.50016 7.16667H7.8335V2.5H9.16683V7.16667ZM3.16683 13.1667H13.8335V8.5H15.1668V13.8333C15.1668 14.0101 15.0966 14.1797 14.9716 14.3047C14.8465 14.4298 14.677 14.5 14.5002 14.5H2.50016C2.32335 14.5 2.15378 14.4298 2.02876 14.3047C1.90373 14.1797 1.8335 14.0101 1.8335 13.8333V8.5H3.16683V13.1667Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1567_21973">
        <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
